var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L20 25H27.5L22.5 15H27.5L32.5 25H40L35 15H40L45 25H52.5L47.5 15H55C56.375 15 57.5521 15.4896 58.5312 16.4688C59.5104 17.4479 60 18.625 60 20V50C60 51.375 59.5104 52.5521 58.5312 53.5312C57.5521 54.5104 56.375 55 55 55H15C13.625 55 12.4479 54.5104 11.4688 53.5312C10.4896 52.5521 10 51.375 10 50V20C10 18.625 10.4896 17.4479 11.4688 16.4688C12.4479 15.4896 13.625 15 15 15ZM15 30V50H55V30H15Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieticket);
export default __webpack_public_path__ + "static/media/movieticket.056c305d641ea4227243f49106a95015.svg";
export { ForwardRef as ReactComponent };